module.exports = __webpack_public_path__ + "img/Most-Improved@3x.d39062ae.png";